<template>
  <div>
    <div class="viewer" ref="viewer"></div>
    <div class="spinner" v-if="spinner"></div>
  </div>
</template>
<script>
const WEBGL = require("../utils/WebGL");
const Viewer = require("../utils/viewer");
const queryString = require("query-string");

export default {
  props: {
    filmboxfileurl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      viewer: null,
      options: null,
      spinner: true,
      fetchOptions: {}
    };
  },
  mounted() {

    if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
      console.error("The File APIs are not fully supported in this browser.");
    } else if (!WEBGL.isWebGLAvailable()) {
      console.error("WebGL is not supported in this browser.");
    }

    const hash = window.location.hash
      ? queryString.parse(window.location.hash)
      : {};

    this.options = {
      model: hash.model || "",
      preset: hash.preset || "",
      cameraPosition: hash.cameraPosition
        ? hash.cameraPosition.split(",").map(Number)
        : null,
      spinner: null,
    };

    this.fetchFile();
  },
  methods: {
    fetchFile() {
      fetch(this.filmboxfileurl)
        .then((res) => res.blob()) // Gets the response and returns it as a blob
        .then((blob) => {
          let file = new File([blob], "Filmbox.fbx");
          let files = new Map([[file.name, file]]);
          //("files", files);
          this.load(files);
        });
    },
    load(fileMap) {
      let rootFile;
      let rootPath;
      Array.from(fileMap).forEach(([path, file]) => {
        if (file.name.match(/\.(fbx)$/)) {
          rootFile = file;
          rootPath = path.replace(file.name, "");
        }
      });

      if (!rootFile) {
        this.onError("No .fbx asset found.");
      }

      this.view(rootFile, rootPath, fileMap);
    },
    view(rootFile, rootPath, fileMap) {
      if (this.viewer) this.viewer.clear();

      if (!this.viewer) this.createViewer();

      const fileURL =
        typeof rootFile === "string" ? rootFile : URL.createObjectURL(rootFile);

      //console.log('rootFile', rootFile);

      this.viewer
        .load(fileURL, rootPath, fileMap)
        .catch((e) => this.onError(e))
        .then(() => {
          if (typeof rootFile === "object") URL.revokeObjectURL(fileURL);

          this.spinner = false;
        });
    },
    createViewer() {
      this.viewer = new Viewer(this.$refs.viewer, this.options);
    },
    onError(error) {
      let message = (error || {}).message || error.toString();
      if (message.match(/ProgressEvent/)) {
        message =
          "Unable to retrieve this file. Check JS console and browser network tab.";
      } else if (message.match(/Unexpected token/)) {
        message = `Unable to parse file content. Verify that this file is valid. Error: "${message}"`;
      } else if (error && error.target && error.target instanceof Image) {
        message = "Missing texture: " + error.target.src.split("/").pop();
      }
      //   window.alert(message);
      //   console.error(error);
    },
  },
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #fff;
}

.viewer {
  width: 100%;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  position: absolute;
  top: 0;
  background-color: #fff;
}

.gui-wrap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  pointer-events: all;
}

/******************************************************************************
 * CSS Spinner
 *
 * http://tobiasahlin.com/spinkit/
 */

.spinner {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px;
  background-color: #333;
  border-radius: 100%;
  -webkit-animation: sk-scaleout 1s infinite ease-in-out;
  animation: sk-scaleout 1s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0;
  }
}
</style>
